import axios from 'axios';
import CONFIG from '../config';

export const getPages = (locale) => axios.get(`${CONFIG.API_BASE}/pages`, {
  params: { locale, v: CONFIG.VERSION }
}).then(res => res.data).then(res => res.data);
